import PersonIconPath from "@ingka/ssr-icon/paths/person";

export default PersonIconPath;
